"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextAction = void 0;
/**
 * The action enum when speech recognition return a final phrase result
 */
var NextAction;
(function (NextAction) {
    NextAction["None"] = "None";
    NextAction["Translate"] = "Translate";
})(NextAction = exports.NextAction || (exports.NextAction = {}));

//# sourceMappingURL=OnSuccess.js.map
